<template>
  <div>
    <el-dialog
      title="选择媒体号"
      :visible.sync="show"
      class="top-draft-dialog"
      :before-close="handleClose"
    >
      <div class="card">
        <div class="col-lg-12 list-header fix-header clearfix">
          <div class="dsply-fix fix-header-item">
            <b-form-input
              v-model="pageParams.content"
              class="w-190 m-r-10"
              size="sm"
              type="text"
              placeholder="请输入搜索内容"
            ></b-form-input>
            <b-form-select
              @change="search()"
              v-model="pageParams.type"
              class="form-select"
              :options="userTypes"
              type="text"
              style="width: 140px; margin-right: 15px"
            ></b-form-select>
            <b-button
              class="m-r-5"
              size="sm"
              variant="primary"
              @click="search()"
            >
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
        </div>
        <div class="table-responsive-main-list">
          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col" style="width: 70px"></th>
                  <th scope="col" style="width: 70px">ID</th>
                  <th scope="col">名称</th>
                  <th scope="col">类型</th>
                  <th scope="col">头像</th>
                  <th scope="col">审核状态</th>
                  <th scope="col">状态</th>
                  <th scope="col">更新时间</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td class="media-dialog-radio">
                    <el-radio v-model="showState" :label="item.id"></el-radio>
                  </td>
                  <td>{{ item.id }}</td>
                  <td class="w-150px white-inherit">{{ item.name }}</td>
                  <td>
                    <span v-if="item.type == 1">汉新闻号</span>
                    <span v-if="item.type == 2">记者/供稿单位</span>
                    <span v-if="item.type == 3">广电矩阵</span>
                  </td>
                  <td>
                    <img
                      v-if="item.avatar"
                      class="w-3-rem"
                      :src="`${item.avatar}`"
                      alt
                    />
                    <img
                      v-if="!item.avatar"
                      class="w-3-rem"
                      src="@/assets/images/default_cover_1_1.png"
                      alt=""
                    />
                  </td>
                  <td>{{ show_state(item.verifyState) }}</td>
                  <td>
                    <span v-if="item.state == 0">冻结</span>
                    <span v-if="item.state == 1">正常</span>
                  </td>
                  <td>{{ item.updatedAt || "--" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <app-list-loading :visible="showLoading"></app-list-loading>
        <pagination
          :total="pageTotal"
          :pageSize="pageParams.pageSize"
          :page.sync="pageParams.page"
          :pageSizes="[10, 20, 30]"
          @pageCallback="pageCallback"
          ref="page"
        ></pagination>

        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button
                @click="handleClose()"
                class="btn-sm btn btn-outline-dark"
                type="button"
              >
                取消
              </button>
              <button
                @click="submitCreate()"
                class="btn-sm btn btn-primary"
                type="button"
              >
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/server/api/media";
import pagination from "@/components/pagination/pagination.vue";
import appListLoding from "@/components/listLoading/index.js";
export default {
  components: {
    pagination,
    appListLoding,
  },

  data() {
    return {
      showLoading: false,
      pageTotal: 0,
      pageParams: {
        content: "",
        type: "",
        pageSize: 10,
        page: 1,
      },
      showState: "",
      items: [],
      show: false,
      userTypes: [
        { text: "筛选类型", value: "" },
        // { text: "普通用户", value: "0" },
        { text: "汉新闻号", value: 1 },
        { text: "记者/供稿单位", value: 2 },
        { text: "广电矩阵", value: 3 },
      ],
    };
  },

  props: {},

  mounted() {},

  methods: {
    showModel(userId) {
      this.resetParams();
      if (userId) {
        this.showState = userId;
      }
      this.show = true;
    },

    handleClose() {
      this.show = false;
    },

    //获取列表数据
    getList() {
      let params = this.another(this.pageParams);
      this.cleanObj(params);
      // this.$refs.loading.show();
      console.log("媒体号搜索参数", params);
      this.showLoading = true;
      api.list(params).then((resp) => {
        console.log("媒体号列表", resp.data);
        if (resp.data) {
          if (resp.data.items) {
            let ids = [];
            resp.data.items.map((item) => {
              ids.push(item.id);
            });
            this.choiceListIds = [];
            this.allListIds = ids; //当前列表全部id
            this.items = resp.data.items;
            this.pageTotal = resp.data.total;
            if (!this.pageTotal) {
              this.showLoading = 1;
            } else {
              this.showLoading = false;
            }

            // let pages = {
            //   page: resp.data.page, //第几页
            //   pageSize: resp.data.pageSize, //每页多少条
            //   total: resp.data.total, //全部有多少条数据
            //   totalPages: resp.data.totalPages, //全部有几页
            // };
            // if (!pages.totalPages) {
            //   pages.totalPages = Math.ceil(
            //     resp.data.total / resp.data.pageSize
            //   );
            // }
          }
        }
      });
    },

    submitCreate() {
      let current = {
        code: "media",
        item: {},
      };
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id == this.showState) {
          current.item = this.items[i];
        }
      }
      this.handleClose();
      this.$emit("pageCallback", current);
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.content = "";
      this.type = "";
      this.getList();
    },
    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
    },
    //显示审核状态
    show_state(state) {
      if (state === 0) {
        return "草稿";
      } else if (state === 1) {
        return "通过";
      } else if (state === 2) {
        return "驳回";
      } else if (state === 3) {
        return "待审核";
      }
    },
  },
};
</script>
